
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcValveAnalogThreeWayIcon as ObcValveAnalogThreeWayIconElement} from '@oicl/openbridge-webcomponents/dist/automation/valve-analog-three-way-icon/valve-analog-three-way-icon.js';
 
 
 

 
 export const ObcValveAnalogThreeWayIcon = createComponent({
   react: React,
   tagName: 'obc-valve-analog-three-way-icon',
   elementClass: ObcValveAnalogThreeWayIconElement,
   events: {
     
   }
  });
 
 